/**
* @description: 设备详情
*/
<template>
    <div class="device-detail" v-loading="state.loading">
        <div class="detail-header">
            <div class="header-main">
                <div class="title">{{ state.device.title || t('deviceDetail.title') }}</div>
                <div class="sub">
                    <span>{{ t('deviceDetail.codeColon') }}：{{ state.device.code || "-" }}</span>
                    <span>{{ t('deviceDetail.modelColon') }}：{{ state.device.model || "-" }}</span>
                    <span>{{ t('deviceDetail.totalHoursColon') }}：{{ state.device.time ?? 0 }} {{ t('deviceDetail.hourUnit') }}</span>
                    <span>{{ t('deviceDetail.kmColon') }}：{{ state.device.kilometer ?? 0 }}</span>
                </div>
            </div>
            <el-button type="primary" @click="openEdit">{{ t('deviceDetail.editDevice') }}</el-button>
        </div>

        <el-tabs v-model="state.activeTab" class="detail-tabs">
            <el-tab-pane :label="t('deviceDetail.tabInfo')" name="info">
                <el-descriptions :column="2" border>
                    <el-descriptions-item :label="t('field.deviceName')">{{ state.device.title || "-" }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.deviceCode')">{{ state.device.code || "-" }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.model')">{{ state.device.model || "-" }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.manufacturer')">{{ state.device.manufacturer || "-" }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.template')">{{ state.device.btitle || "-" }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.status')">{{ statusLabel }}</el-descriptions-item>
                    <el-descriptions-item :label="t('deviceDetail.totalWorkHours')">{{ state.device.time ?? 0 }} {{ t('deviceDetail.hourUnit') }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.initialWorkHours')">{{ state.device.chu_time ?? 0 }} {{ t('deviceDetail.hourUnit') }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.kilometer')">{{ state.device.kilometer ?? 0 }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.initialKilometer')">{{ state.device.chu_kilometer ?? 0 }}</el-descriptions-item>
                    <el-descriptions-item :label="t('field.maintenanceTime')" :span="2">
                        {{ formatDisplayDate(state.device.created_at) || '-' }}
                    </el-descriptions-item>
                </el-descriptions>
            </el-tab-pane>

            <el-tab-pane :label="t('deviceDetail.tabWorkTime')" name="workTime">
                <DeviceWorkTimePanel v-if="state.device.id" :device-id="state.device.id" />
            </el-tab-pane>
        </el-tabs>

        <EditDevice
            ref="editDeviceRef"
            :title="t('deviceDetail.editDevice')"
            :statusOptions="statusOptions"
            @refresh="loadDevice"
        />
    </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import EditDevice from "./components/deviceAdd.vue";
import DeviceWorkTimePanel from "./components/deviceWorkTimePanel.vue";
import { detailApi } from "@/api/system/device";
import { formatDisplayDate } from "@/utils/dateTime.js";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const route = useRoute();
const editDeviceRef = ref();

const statusOptions = reactive([
    { label: t('common.all'), value: 99 },
    { label: t('status.available'), value: 1 },
    { label: t('status.warehouse'), value: 0 },
]);

const state = reactive({
    loading: false,
    activeTab: "info",
    device: {},
});

const applyLabels = () => {
    statusOptions[0].label = t('common.all');
    statusOptions[1].label = t('status.available');
    statusOptions[2].label = t('status.warehouse');
};

usePageI18n(applyLabels);

const statusLabel = computed(() => {
    const item = statusOptions.find((i) => i.value === state.device.status);
    return item?.label ?? "-";
});


const normalizeDevice = (d) => {
    if (!d) return {};
    return {
        ...d,
        chu_time: d.chu_time ?? d.chuTime ?? 0,
        chu_kilometer: d.chu_kilometer ?? d.chuKilometer ?? 0,
        created_at: d.created_at ?? d.createdAt,
        device_id: d.device_id ?? d.deviceId,
    };
};

const loadDevice = () => {
    const id = route.query.id;
    if (!id) return;
    state.loading = true;
    detailApi(JSON.stringify({ id })).then((res) => {
        if (res?.code === 200) {
            state.device = normalizeDevice(res.data);
        } else {
            ElMessage.error(res?.msg || t('deviceList.loadFailed'));
        }
    }).finally(() => {
        state.loading = false;
    });
};

const openEdit = () => {
    editDeviceRef.value?.open(state.device);
};

watch(
    () => route.query.id,
    () => loadDevice(),
);

onMounted(() => {
    applyLabels();
    if (route.query.tab) {
        state.activeTab = route.query.tab;
    }
    loadDevice();
});
</script>

<style lang="less" scoped>
.device-detail {
    padding: 16px;
    background: #fff;
    border-radius: 6px;
    margin-right: 10px;
}
.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
}
.title {
    font-size: 20px;
    font-weight: 600;
}
.sub {
    margin-top: 8px;
    color: #666;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
</style>
